
import { useAuth } from '@/hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, session, loading } = useAuth();

  useEffect(() => {
    console.log('🛡️ [PROTECTED ROUTE] Auth state:', { 
      user: user?.email, 
      hasSession: !!session, 
      loading 
    });
  }, [user, session, loading]);

  if (loading) {
    console.log('🛡️ [PROTECTED ROUTE] Still loading auth state');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Check both user and session for extra security
  if (!user || !session) {
    console.log('🛡️ [PROTECTED ROUTE] No user or session, redirecting to auth');
    return <Navigate to="/auth" replace />;
  }

  console.log('🛡️ [PROTECTED ROUTE] User authenticated, rendering protected content');
  return <>{children}</>;
};

export default ProtectedRoute;
export { ProtectedRoute };
